<template>
  <div>
    <el-drawer
      title="唯格云文章选择器"
      :visible.sync="showDrawer"
      direction="btt"
      size="90%"
      append-to-body
      @closed="onClose"
    >
      <div class="main-container" ref="mainContainer">
        <div class="filter-row">
          <el-button size="small" icon="el-icon-search" @click="handleSearch"
            >刷新</el-button
          >
          &nbsp;
          <el-input
            placeholder="请输入内容"
            v-model="currentQuery.title"
            class="input-title"
            @change="handleSearch"
            clearable
            @clear="handleSearch"
            size="small"
          >
            <el-button slot="prepend" icon="el-icon-search"></el-button>
          </el-input>
          &nbsp;
          <el-checkbox-group
            v-model="currentQuery.typeId"
            @change="handleSearch"
            size="small"
          >
            <el-checkbox-button
              v-for="item in typeOptions"
              :label="item.id"
              :key="item.name"
              >{{ item.name }}</el-checkbox-button
            >
          </el-checkbox-group>
        </div>
        <div class="table-container" ref="tableContainer">
          <el-table
            class="base-table"
            :data="tableData"
            border
            :style="tableStyle"
            :size="tableSize"
            :height="tableHeight"
            header-cell-class-name="baseTableHeadStyle"
            ref="multipleTable"
            row-class-name="customs-table-row"
            v-loading="tableLoading"
            element-loading-text="查询中..."
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              fixed="left"
            />
            <el-table-column type="index" align="center" width="50" />
            <template v-for="column in tableColumns">
              <el-table-column
                v-if="column.showColumn"
                v-bind="column"
                :show-overflow-tooltip="true"
                :key="column.prop"
              >
                <template slot-scope="scope">
                  <el-image
                    v-if="column.prop === 'descriptionImageUrl'"
                    style="width: 66px; height: 66px;"
                    :src="scope.row.descriptionImageUrl"
                    :preview-src-list="[scope.row.descriptionImageUrl]"
                  >
                  </el-image>
                  <span v-else-if="column.prop === 'postAt'">{{
                    scope.row.postAt | date_time
                  }}</span>
                  <span v-else>{{ scope.row[column.prop] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div class="custom-table-footer">
          <el-pagination
            class="base-table-pagination"
            :disabled="tableLoading"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="page + 1"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <el-button
            class="mt-r"
            size="small"
            type="primary"
            icon="el-icon-circle-check"
            @click="handleConfrim"
            >确定 {{ selections.length }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { ShowApiError } from "@/request/error";
import { GetArticlesList } from "../api/viewgres_v4";

import form from "../mixins/form";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins: [form],
  data() {
    return {
      typeOptions: [
        {
          id: "PRODUCT",
          name: "产品"
        },
        {
          id: "ENGINEERING_CASE",
          name: "项目案例"
        },
        {
          id: "TECHNOLOGY",
          name: "技术与应用"
        },
        {
          id: "NEWS",
          name: "新闻"
        }
      ],
      tableStyle: {
        width: "100%",
        height: "100%"
      },
      tableHeight: "500px",
      tableSize: "medium",
      tableLoading: false,
      isMultiple: false,
      tableColumns: [],
      page: 0,
      size: 20,
      total: 0,
      tableData: [],
      orderProp: "postAt",
      orderDirection: "descending",
      currentQuery: {
        title: "",
        typeId: []
      },
      selections: [],
      showDrawer: false
    };
  },
  watch: {
    multiple: {
      handler(value) {
        this.isMultiple = value;
      },
      immediate: true
    },
    query: {
      handler(value) {
        if (Object.keys(value).length > 0) {
          this.currentQuery = { ...this.currentQuery, ...value };
        }
      },
      immediate: true,
      deep: true
    },
    show: {
      handler(value) {
        this.showDrawer = value;
        if (this.showDrawer) {
          if (
            this.tableData.length === 0 ||
            Object.keys(this.query).length > 0
          ) {
            this.getTableData();
          }
          this.$nextTick(() => {
            this.tableHeight = `${this.$refs["tableContainer"].clientHeight}px`;
            // console.dir(this.$refs["tableContainer"].clientHeight);
          });
        }
      },
      immediate: true
    }
  },
  created() {
    this.buildTableColumns();
  },

  methods: {
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "typeName",
            label: "类型",
            showColumn: true,
            minWidth: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "title",
            label: "标题",
            showColumn: true,
            minWidth: 150,

            sortable: "custom"
          },
          {
            prop: "postAt",
            label: "发布时间",
            minWidth: 120,
            align: "center",
            showColumn: true,
            sortable: "custom"
          },
          {
            prop: "descriptionText",
            label: "描述",
            minWidth: 150,
            showColumn: true,
            sortable: "custom"
          },
          {
            prop: "descriptionImageUrl",
            label: "描述图片",
            width: 120,
            align: "center",
            showColumn: true,
            sortable: "custom"
          },

          {
            prop: "referenceUrl",
            label: "引用地址",
            align: "center",
            showColumn: true,
            minWidth: 120,
            sortable: "custom"
          },
          {
            prop: "poster_image_url",
            label: "海报图片",
            showColumn: true,
            minWidth: 130,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "posterSlogan",
            label: "海报标语",
            align: "left",
            showColumn: true,
            width: 120,
            sortable: "custom"
          },
          {
            prop: "content",
            label: "内容",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "user_name_create",
            label: "创建人",
            align: "left",
            showColumn: true,
            width: 120,
            sortable: "custom"
          },
          {
            prop: "utc_create",
            label: "创建日期",
            align: "center",
            showColumn: true,
            width: 130,
            sortable: "custom"
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            width: 120,
            align: "center",
            showColumn: true,
            sortable: false
          },
          {
            prop: "utc_modified",
            label: "更新日期",
            align: "center",
            showColumn: true,
            width: 130,
            sortable: "custom"
          },

          {
            prop: "id",
            label: "ID",
            align: "left",
            showColumn: true,
            width: 100,
            sortable: "custom"
          },
          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 80
          }
        ];
      }
    },
    getTableData() {
      this.tableLoading = true;
      GetArticlesList({
        page: this.page,
        size: this.size,
        sort: `postAt,desc`,
        ...this.currentQuery
      })
        .then(res => {
          let { content, totalElements } = res.data;
          this.tableData = content;

          this.total = totalElements;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;

          ShowApiError("拉取列表错误", err);
        });
    },
    handleSearch() {
      this.page = 0;
      this.getTableData();
    },
    handleSelectionChange(data) {
      if (this.isMultiple) {
        this.selections = data;
      } else {
        if (data.length > 0) {
          this.selections = data.slice(0, 1);
        }
      }
    },
    handleConfrim() {
      this.$emit("change", this.selections);
    },
    onClose() {
      this.showDrawer = false;
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .table-container {
    box-sizing: border-box;
    flex: 1 0 0;
    padding: 0 24px;
    overflow: hidden;
  }
  .base-table {
    width: 100%;
    height: 100%;
  }
}

.custom-table-footer {
  flex: 56px 0 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
}
.input-title {
  width: 250px;
}
.filter-row {
  width: 100%;
  margin-bottom: 12px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
